import React from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { PhoneDisplayWithFlag } from '../phone-display/PhoneDisplayWithFlag';
import { MessageContact } from '@bt-common/schemas/bt/user-message';

interface ContactCellProps {
    contactList?: MessageContact[];
    contactName?: string;
}

export const ContactCell: React.FC<ContactCellProps> = ({ contactList, contactName }) => {
    const contact = contactList?.[0];
    const name = contact?.name || 
                (contact?.firstName || contact?.lastName ? `${contact.firstName || ''} ${contact.lastName || ''}`.trim() : null) || 
                (contactName !== 'Unknown' ? contactName : null);
    const mobile = contact?.mobile;
    const id = contact?.id;

    if (!name && !mobile && !id) {
        return <span className="text-muted-foreground text-xs italic">Unknown</span>;
    }

    return (
        <div className="flex flex-col gap-0.5">
            {name && (
                <span className="font-bold text-sm text-foreground">
                    {name}
                </span>
            )}
            {mobile && mobile !== id && (
                <PhoneDisplayWithFlag 
                    phone={mobile} 
                    className="text-xs font-medium text-muted-foreground"
                />
            )}
            {id && (
                <div className="flex items-center gap-1 group">
                    <span className={`font-mono ${name || (mobile && mobile !== id) ? 'text-[10px] text-muted-foreground/60' : 'text-xs font-bold text-foreground'}`}>
                        {id}
                    </span>
                    <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(id);
                            toast.success("Contact ID copied");
                        }}
                        className="opacity-0 group-hover:opacity-100 p-0.5 hover:bg-muted rounded transition-opacity"
                        title="Copy ID"
                    >
                        <Copy className="h-2.5 w-2.5" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ContactCell;
